/* eslint-disable @typescript-eslint/no-explicit-any */
import { localKey } from "@/dto/local.key.dto";
import router from "@/router";
interface APIResponse {
  statusCode: number;
  expired: boolean;
  data?: object;
  meta?: object;
  message: string;
}

export const apiSuccessResponse: (response: any) => APIResponse = (
  response
) => {
  const statusCode = response?.status || 500;
  const expired = false;
  const data = response?.data?.data || response?.data || [];
  const meta = customPagination(
    data,
    response?.data?.meta || response?.meta || {}
  );
  const message = response?.data?.message || response?.message || "";
  const success = true;
  return { success, statusCode, expired, data, meta, message };
};

export const apiSuccessFeature: (response: any) => APIResponse = (response) => {
  const statusCode =
    response?.data?.statusCode ||
    response?.statusCode ||
    response?.status ||
    500;
  const expired = false;
  const data = response?.data?.data || response?.data || [];
  const meta = customPagination(
    data,
    response?.data?.meta || response?.meta || {}
  );
  const message = response?.data?.message || response?.message || "";
  const success = true;

  return { success, statusCode, expired, data, meta, message };
};

export const apiErrorResponse: (response: any) => APIResponse = (response) => {
  if (!response?.response) {
    throw new Error(response);
  }

  const statusCode =
    response?.response?.data?.statusCode || response?.response?.status || 500;
  const expired = statusCode === 4410; // Token expired
  const data = response?.response?.data?.data || [];
  const meta = response?.response?.data?.meta || {};
  const message =
    response?.response?.data?.message ||
    response?.message ||
    "Server error occurred";

  // Handle specific error status codes
  switch (statusCode) {
    case 4401: // Unauthorized
    case 4400: // Invalid JSON web token
      forceLogout();
      break;
    case 4403: // Invalid authorization scheme
      forceLogout();
      break;
    case 4413: // Forbidden
      forceLogout();
      break;
    case 4410: // Token expired
      break;
    default:
      break;
  }

  return { statusCode, expired, data, meta, message };
};

export const customPagination = (data: any, meta: any) => {
  if (!meta?.total) {
    return {};
  }

  const totalPage = meta.total / meta.limit;
  const pagination = {
    limit: meta.limit,
    totalPage: Math.ceil(totalPage),
    page: meta.offset / meta.limit + 1,
    length: meta.total,
    offset: meta.total > data.length ? meta.offset + meta.limit : meta.offset,
  };

  return pagination;
};

export const forceLogout = async (): Promise<void> => {
  try {
    localStorage.removeItem(localKey?.accessToken);
    localStorage.removeItem(localKey?.refreshToken);
    await router.push({ path: "/login" });
    location.reload();
  } catch (err) {
    console.error("Failed to navigate to login page:", err);
  }
};
